import { nanoid } from 'nanoid';
import React, {
  createContext, useEffect, useMemo, useReducer,
} from 'react';

export const KickCounterContext = createContext();

const kickCounterReducer = (state, action) => {
  switch (action.type) {
    case 'add_kick':
      return { ...state, kickList: [...state.kickList, action.payload] };
    case 'delete_kick':
      return { ...state, kickList: state.kickList.filter((item) => item.id !== action.payload.id) };
    case 'change_kick_counter_mode':
      return { ...state, counterMode: action.payload };
    case 'set_time':
      return { ...state, time: action.payload };
    case 'set_session_start_time':
      return { ...state, sessionStartTime: action.payload };
    case 'set_session_end_time':
      return { ...state, sessionEndTime: action.payload };
    case 'set_start_time':
      return { ...state, startTime: action.payload };
    case 'set_counter_active':
      return { ...state, active: action.payload };
    case 'set_session_strength':
      return { ...state, strength: action.payload };
    default:
      return state;
  }
};

const initState = JSON.parse(sessionStorage.getItem('kickCounterState')) || {
  kickList: [], time: 0, active: false, strength: 3, startTime: null, sessionStartTime: null,
};

export function KickCounterProvider({ children }) {
  const [state, dispatch] = useReducer(kickCounterReducer, initState);

  useEffect(() => {
    sessionStorage.setItem('kickCounterState', JSON.stringify(state));
  }, [state]);

  const addKick = (kickType, timestamp) => {
    const id = nanoid();
    const createdAt = new Date();
    dispatch({
      type: 'add_kick',
      payload: {
        kickType, timestamp, id, createdAt,
      },
    });
  };

  const deleteKick = (id) => {
    dispatch({ type: 'delete_kick', payload: { id } });
  };

  const changeKickCounterMode = (mode) => {
    dispatch({ type: 'change_kick_counter_mode', payload: mode });
  };

  const setTime = (time) => {
    dispatch({ type: 'set_time', payload: time });
  };

  const setStartTime = (startTime) => {
    dispatch({ type: 'set_start_time', payload: startTime });
  };

  const setSessionStartTime = (sessionStartTime) => {
    dispatch({ type: 'set_session_start_time', payload: sessionStartTime });
  };

  const setSessionEndTime = (sessionEndTime) => {
    dispatch({ type: 'set_session_end_time', payload: sessionEndTime });
  };

  const setCounterActive = (active) => {
    dispatch({ type: 'set_counter_active', payload: active });
  };

  const setSessionStrength = (strength) => {
    dispatch({ type: 'set_session_strength', payload: strength });
  };

  const value = useMemo(() => ({
    ...state,
    addKick,
    deleteKick,
    changeKickCounterMode,
    setTime,
    setStartTime,
    setCounterActive,
    setSessionStrength,
    setSessionStartTime,
    setSessionEndTime,
  }), [state]);

  return (
    <KickCounterContext.Provider value={value}>
      {children}
    </KickCounterContext.Provider>
  );
}
